import { useLocation } from "react-router-dom";
import { parse } from "qs";

import type { Crumb } from "app/components/ui/Breadcrumb/Breadcrumbs";
import { isSafeInternalPath } from "../utils/isSafeInternalPath";
import {
	BREADCRUMB_ORIGIN_FROM_PARAM,
	BREADCRUMB_ORIGIN_PATH_PARAM,
} from "../constants/breadcrumbOrigin";

/** Builds a crumb from the origin in the URL: link only if the path is a safe internal route, null when the name is absent. */
export const useBreadcrumbOrigin = (): Crumb | null => {
	const { search } = useLocation();
	const query = parse(search, { ignoreQueryPrefix: true });

	const rawFrom = query[BREADCRUMB_ORIGIN_FROM_PARAM];
	if (typeof rawFrom !== "string") {
		return null;
	}

	const label = rawFrom.trim();

	if (label.length === 0) {
		return null;
	}

	const rawPath = query[BREADCRUMB_ORIGIN_PATH_PARAM];

	if (isSafeInternalPath(rawPath)) {
		return { label, to: rawPath };
	}

	return { label };
};
